<template>
  <div class="app">
    <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="mx-auto app-login-box col-8">
        <div class="mb-3 d-flex align-items-center justify-content-center">
          <img alt="logo" :src="obterLogo" width="200" class="img-fluid">
        </div>
        <div class="modal-dialog w-100 mx-auto">
          <div class="modal-content">
            <div class="modal-body">
              <div class="h5 modal-title text-center">
                <h4 class="mt-2">
                  <div><h2>Bem vindo,</h2></div>
                    <span>Este é o seu primeiro login no sistema, para sua maior segurança, favor alterar sua senha conforme padrão de criptografia:</span>
                    <span><strong> no mínimo uma letra, uma letra maiúscula, um número e 8 caracteres.</strong></span>
                </h4>
              </div>
              <form>
                <div class="form-group col-md-12">
                  <label for="inputSenhaAtual" class="required">Senha Atual</label>
                  <input type="password" v-model="formulario.f_original_password" @keyup="eventoLoginTeclaEnter" @input="limparListaErros" :disabled="flagsDeControle.manipulandoDados.status" autocomplete="off" class="form-control" id="inputSenhaAtual">
                  <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_original_password}}</div>
                </div>
                <div class="form-group col-md-12">
                  <label for="inputNovaSenha" class="required">Nova Senha</label>
                  <input type="password" v-model="formulario.f_new_password" @keyup="eventoLoginTeclaEnter" @input="limparListaErros" :disabled="flagsDeControle.manipulandoDados.status" autocomplete="off" class="form-control" id="inputNovaSenha">
                  <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_new_password}}</div>
                </div>
                <div class="form-group col-md-12">
                  <label for="inputConfirmarSenha" class="required">Confirmar Senha</label>
                  <input type="password" v-model="formulario.f_confirm_password" @keyup="eventoLoginTeclaEnter" @input="limparListaErros" :disabled="flagsDeControle.manipulandoDados.status" autocomplete="off" class="form-control" id="inputConfirmarSenha">
                  <div class="avisoDanger text-left mt-1">{{retorno.listaDeErros.f_confirm_password}}</div>
                </div>
                <div class="col-12 text-right">
                  <b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status" @click="alterarSenha()">Salvar</b-button>
                </div>
                <div v-if="flagsDeControle.manipulandoDados.status" class="d-flex align-items-center">
                  <span class="avisoDanger">{{flagsDeControle.manipulandoDados.mensagem}}</span>
                  <b-spinner class="ml-2" variant="danger"></b-spinner>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrimeiroAcesso from './js/primeiroAcesso'
export default PrimeiroAcesso
</script>

<style scoped>
@import "./scss/login.scss";
</style>
